import type { Gradient } from '@jouzen/ecom-components';

const DESKTOP_CLASS_NAME = 'hidden lg:block';
const MOBILE_CLASS_NAME = 'lg:hidden';

export const popGradients: Gradient[] = [
  {
    shape: 'circle',
    hex: '#686B6A',
    id: 'slate-1',
    position: [95, 60],
    opacity: 0.1,
    size: 20,
    className: MOBILE_CLASS_NAME,
  },
  {
    shape: 'ellipse',
    hex: '#A4A4A4',
    id: 'slate-2',
    position: [50, 60],
    opacity: 0.1,
    size: 30,
    className: MOBILE_CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D3D3D3',
    id: 'slate-3',
    position: [50, 75],
    opacity: 0.5,
    size: 20,
    className: MOBILE_CLASS_NAME,
  },
  {
    shape: 'ellipse',
    hex: '#686B6A',
    id: 'slate-4',
    position: [95, 75],
    opacity: 0.1,
    size: 35,
    className: MOBILE_CLASS_NAME,
  },
  {
    shape: 'ellipse',
    hex: '#A4A4A4',
    id: 'slate-5',
    position: [15, 20],
    opacity: 0.2,
    size: 10,
    className: DESKTOP_CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#686B6A',
    id: 'slate-6',
    position: [85, 25],
    opacity: 0.3,
    size: 20,
    className: DESKTOP_CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D3D3D3',
    id: 'slate-7',
    position: [25, 45],
    opacity: 0.6,
    size: 15,
    className: DESKTOP_CLASS_NAME,
  },
  {
    shape: 'ellipse',
    hex: '#686B6A',
    id: 'slate-8',
    position: [80, 45],
    opacity: 0.2,
    size: 20,
    className: DESKTOP_CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#A4A4A4',
    id: 'slate-9',
    position: [15, 55],
    opacity: 0.3,
    size: 10,
    className: DESKTOP_CLASS_NAME,
  },
  {
    shape: 'circle',
    hex: '#D3D3D3',
    id: 'slate-10',
    position: [25, 65],
    opacity: 0.6,
    size: 15,
    className: DESKTOP_CLASS_NAME,
  },
  {
    shape: 'ellipse',
    hex: '#686B6A',
    id: 'slate-11',
    position: [80, 65],
    opacity: 0.2,
    size: 20,
    className: DESKTOP_CLASS_NAME,
  },
];
